import React, { useRef, useEffect, useState } from 'react';
import './Chart.scss';
import D3SpiderChart from './D3SpiderChart';

const ChartWrapper = (props) => {
	const svgRef = useRef();
	const svgContainerRef = useRef();
	const [chart, setChart] = useState(null)

	useEffect(() => {
		setChart(new D3SpiderChart({ svgRef: svgRef, chartId: props.chartId, svgContainerRef: svgContainerRef }))
	}, [props.chartId])

	useEffect(() => {
		function handleResize() {
			if (chart) {
				chart.updateChart(props.data, props.colour, props.ind, props.volume, props.isMobile);
			}
		}
		window.addEventListener('resize', handleResize)
		return _ => window.removeEventListener('resize', handleResize)
	})
	useEffect(() => {
		if (chart) {
			chart.updateChart(props.data, props.colour, props.ind, props.volume, props.isMobile);
		}
	}, [chart, props])

	return (
		<React.Fragment>
			<div id="TnC-chart__tooltip" style={{ display: "none" }}></div>
			<div className="TnC-map__chart-area">
				<div ref={svgContainerRef} className="soldo-datavis__svgContainer">
					<svg style={{ pointerEvents: "visibleFill" }}
						id="chart" width="800" height="600"
						ref={svgRef} className="TnC-map__svg"
					>
					</svg>
				</div>
			</div>
		</React.Fragment>
	)
}

export default ChartWrapper